import React from 'react';
import { formatNumber } from '../../utils/format';

const AmountInput = ({ 
  amount, 
  onAmountChange, 
  balance, 
  onMaxClick, 
  disabled = false,
  isWrongNetwork = false,
  sourceChainName = ''
}) => {
  const handleAmountChange = (e) => {
    const value = e.target.value;
    // Allow empty string, numbers, and decimal points
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      onAmountChange(value);
    }
  };

  const formatBalance = (balance) => {
    if (!balance || balance === '0') return '0';
    const num = parseFloat(balance);
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(2)}M`;
    } else if (num >= 1000) {
      return `${(num / 1000).toFixed(2)}K`;
    } else {
      return formatNumber(num, 6);
    }
  };

  const isMaxDisabled = !balance || parseFloat(balance) === 0 || disabled;

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300">
          Amount
        </label>
        <div className="text-sm text-slate-500 dark:text-slate-400">
          {isWrongNetwork ? (
            <span className="text-blue-600 dark:text-blue-400">
              Switching to {sourceChainName}...
            </span>
          ) : (
            `Balance: ${formatBalance(balance)} PFVS`
          )}
        </div>
      </div>

      <div className="relative">
        <input
          type="text"
          value={amount}
          onChange={handleAmountChange}
          placeholder="0.0"
          disabled={disabled}
          className="input-field pr-20 text-lg font-medium"
        />
        
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center gap-2">
          <button
            type="button"
            onClick={onMaxClick}
            disabled={isMaxDisabled}
            className="px-2 py-1 bg-primary-100 hover:bg-primary-200 dark:bg-primary-800 dark:hover:bg-primary-700 text-primary-700 dark:text-primary-300 rounded text-xs font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            MAX
          </button>
          <span className="text-slate-500 dark:text-slate-400 font-medium">
            PFVS
          </span>
        </div>
      </div>

      {/* Amount validation feedback */}
      {amount && parseFloat(amount) > 0 && (
        <div className="mt-2">
          {parseFloat(balance) < parseFloat(amount) && (
            <p className="text-error-500 text-sm">
              Amount exceeds available balance
            </p>
          )}
          {parseFloat(amount) < 0.01 && (
            <p className="text-warning-500 text-sm">
              Minimum amount is 0.01 PFVS
            </p>
          )}
          {parseFloat(amount) > 1000000 && (
            <p className="text-warning-500 text-sm">
              Maximum amount is 1,000,000 PFVS
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default AmountInput; 